import React from "react";
import { useSelector } from "react-redux";
import { faCheck, faGhost, faTh } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import * as editorActions from "@/lib/state/actions/editor-actions";
import { editorSelector } from "@/lib/state/selectors/editor-selector";
import { useAppDispatch } from "@/lib/state/store";

import DropdownMenu, {
  DropdownMenuEntry,
} from "../dropdown-menu/dropdown-menu";

const EditorViewMenu = () => {
  const dispatch = useAppDispatch();
  const { showOnionSkins, showGrid } = useSelector(editorSelector);

  const menuItems: DropdownMenuEntry[] = [
    {
      icon: faTh,
      text: (
        <span>
          Show pixel grid {showGrid ? <FontAwesomeIcon icon={faCheck} /> : null}
        </span>
      ),
      onClick: () => dispatch(editorActions.toggleGrid()),
    },
    {
      icon: faGhost,
      text: (
        <span>
          Show onion skins{" "}
          {showOnionSkins ? <FontAwesomeIcon icon={faCheck} /> : null}
        </span>
      ),
      onClick: () => dispatch(editorActions.toggleOnionSkins()),
    },
  ];

  return (
    <DropdownMenu
      align="left"
      button={{
        text: "View",
        type: "transparent",
      }}
      items={menuItems}
    />
  );
};

export default EditorViewMenu;
